export default __webpack_public_path__ + "static/media/fr_CA.1ea5ada6.svg";